var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('am2-tag',{attrs:{"text":(_vm.valueText + "%"),"type":_vm.valueAsInt >= 0 ? 'green' : 'red',"shape":"rectangle","icon-name":"arrow","icon-props":{
    rotate: _vm.valueAsInt >= 0 ? 180 : 0,
  }}})}
var staticRenderFns = []

export { render, staticRenderFns }